module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAgCAYAAACl36CRAAAAAXNSR0IArs4c6QAAAIVJREFUaEPtlzsOwDAIQ8vpODOna9Uxar2wgV/GREjxR2Ciqu5LnMwM9bahLjaA6IoEeGz/w0DXTlPqsL2t7RVwh3s5xwG/nAGUXy6whOetPNmere7LwJSY2v0n8dY23tLwXBuea8B5cXuHHJQ3ZcDb9ow611GH8ijPVncw0F0Vp9RZr7QP0UWSosK80H4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title.png
// module id = 05xs
// module chunks = 32